"use strict";

/* -------------------------------------------------------------------------

	PUNITED.office

	トップページのスクリプトを定義
	※jQuery必須
	Potential United inc.

------------------------------------------------------------------------- */
// グローバル名前空間定義
var PUNITED;
if (!PUNITED) PUNITED = {};
if (!PUNITED.office) PUNITED.office = {};

(function () {
  // グローバル名前空間オブジェクトをローカルオブジェクトに置き換え
  var ns = PUNITED.office;
  /* -----------------------------------------------------
  
  ----------------------------------------------------- */

  ns.handleMapSize = function () {
    var img = document.querySelector('.building_gallery__plan img');
    var map = document.querySelector('.building_gallery__plan map');
    var areas = map.querySelectorAll('area');
    var width = parseInt(img.getAttribute('width'), 10);
    var height = parseInt(img.getAttribute('height'), 10);
    var coords = Array.from(areas).map(function (area) {
      var flat = area.getAttribute('coords').split(',').map(function (coord) {
        return parseInt(coord, 10);
      });
      var groups = [];

      for (var i = 0; i < flat.length; i += 2) {
        groups.push([flat[i], flat[i + 1]]);
      }

      return groups;
    });
    resize();
    var observer = new ResizeObserver(resize);
    observer.observe(img);

    function resize() {
      var ratioX = img.offsetWidth / width;
      var ratioY = img.offsetHeight / height;
      areas.forEach(function (area, i) {
        area.setAttribute('coords', coords[i].map(function (coord) {
          return "".concat(Math.round(coord[0] * ratioX), ",").concat(Math.round(coord[1] * ratioY));
        }).join(','));
      });
    }
  };

  ns.handleSliderModal = function () {
    var modalEl = document.querySelector('#gallery_modal');
    var modal = PUNITED.utils.modal(modalEl);
    var sliders = modalEl.querySelectorAll('.img_slider');
    var slidersMap = {};
    sliders.forEach(function (container) {
      var slider = container.querySelector('.splide'); // const slideSpeed = 2000;
      // const slideDelay = 3000;

      var nav = slider.querySelector('.img_slider__nav');
      var slides = slider.querySelectorAll('.splide__slide');
      var single = slides.length === 1;
      nav.style.display = single ? 'none' : '';
      var splide = new Splide(slider, {
        type: 'fade',
        rewind: true,
        // speed: slideSpeed,
        easing: 'ease' // arrows: !single,
        // pagination: !single,
        // breakpoints: {
        // 	680: {
        // 		gap: 20,
        // 	},
        // }

      });
      splide.mount();
      slidersMap["#".concat(container.id)] = splide;
    });
    var triggers = document.querySelectorAll('.building_gallery__item, area');
    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', handleClick);
    });

    function handleClick(e) {
      e.preventDefault();
      var href = e.currentTarget.getAttribute('href');
      var id = href.replace('#', '');
      sliders.forEach(function (slider) {
        slider.style.display = slider.id !== id ? 'none' : '';
      });
      slidersMap[href].refresh();
      modal.open();
    }
  };
})();

$(function () {
  PUNITED.office.handleMapSize();
  PUNITED.office.handleSliderModal();
});